export const error = {
    _401_UNAUTHORIZED: 401,
    _403_FORBIDDEN: 403,
    _404_NOT_FOUND: 404,
};